(function () {
  /**
   * @ngdoc component
   * @name abxFooter
   *
   * @description
   * A footer container that dynamically hides depending on virtual keyboard state
   */
  angular
    .module("akitabox.mobile.components.footer", [
      "akitabox.core.services.flag",
      "akitabox.core.services.organization",
      "akitabox.core.services.user",
    ])
    .controller("Footer", FooterController)
    .component("abxFooter", {
      bindings: {
        addWorkOrder: "<abxAddWorkOrder",
        addServiceRequest: "<abxAddServiceRequest",
        hideAddButton: "<?abxHideAddButton",
        backDefault: "@?abxBackDefault",
      },
      controller: FooterController,
      controllerAs: "vm",
      templateUrl: "app/mobile/components/footer/footer.component.html",
    });

  /** @ngInject */
  function FooterController(
    // Angular
    $window,
    // Services
    OrganizationService,
    UserService
  ) {
    var self = this;

    // Private Constants
    var MIN_KEYBOARD_HEIGHT = 100;
    var DEBOUNCE_DELAY = 100;

    var debouncedOnResize = angular.debounce(onResize, DEBOUNCE_DELAY);

    // Attributes
    self.displayFooter = true;
    self.screenWidth = 0;
    self.screenHeight = 0;
    self.window = $window;
    self.createMenuOpen = false;
    self.navigationMenuOpen = false;
    self.organization = OrganizationService.getCurrent();
    self.showAddButton = showAddButton();
    self.goToHelp = goToHelp;

    // Functions
    self.onResize = onResize;
    self.toggleCreateMenu = toggleCreateMenu;
    self.toggleNavigationMenu = toggleNavigationMenu;
    self.closeOverlay = closeOverlay;

    updateScreenDimensions();

    angular.element(self.window).on("resize", debouncedOnResize);

    /**
     * When screen resizes, first see if the orientation string changes
     * If it has, no need to check if keyboard is opening
     * If it hasn't check to see if vertical height has been reduced
     */
    function onResize() {
      if (screenWidthChanged() === false) {
        var newHeight = self.window.innerHeight;
        // if the screen height has been reduced by more than the min keyboard height, toggle the displayFooter
        self.displayFooter =
          self.screenHeight - newHeight < MIN_KEYBOARD_HEIGHT;
      }
      updateScreenDimensions();
    }

    function toggleCreateMenu() {
      self.createMenuOpen = !self.createMenuOpen;
    }

    function toggleNavigationMenu() {
      self.navigationMenuOpen = !self.navigationMenuOpen;
    }

    function closeOverlay() {
      self.navigationMenuOpen = false;
      self.createMenuOpen = false;
      self.overlayOpen = false;
    }

    function screenWidthChanged() {
      return self.screenWidth !== self.window.innerWidth;
    }

    function updateScreenDimensions() {
      self.screenWidth = self.window.innerWidth;
      self.screenHeight = self.window.innerHeight;
    }

    function showAddButton() {
      var showTasks = self.organization && self.organization.show_tasks;
      var permissions = UserService.getPermissions();
      return (
        showTasks &&
        (permissions.request.create || permissions.task.create) &&
        !self.hideAddButton
      );
    }

    function goToHelp() {
      $window.location.href = "https://akitabox.zendesk.com";
    }
  }
})();
